import React from "react"
import ModalButtons from "../ModalButtons/ModalButtons"
import Tabs from '../Tabs/Tabs'
import DatesAndTimesBuilderTabContent from "./DatesAndTimesBuilderTabContent"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"

class DatesAndTimesBuilder extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      date_format: this.props.date_setting.date_format,
      time_format: this.props.date_setting.time_format,
      time_zone: this.props.date_setting.time_zone,
      active_tab: 'general',
      loading: false
    }
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeTime = this.onChangeTime.bind(this);
    this.onChangeZone = this.onChangeZone.bind(this);
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
  }

  onChangeDate(e) {
    this.setState({
      date_format: e.target.value
    })
  }

  onChangeTime(e) {
    this.setState({
      time_format: e.target.value
    })
  }

  onChangeZone(e) {
    this.setState({
      time_zone: e.target.value
    })
  }

  render() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          self.onSave();
          return false;
        },
      },
    ]
    return (
      <div className="dates-and-times-builder">
        <Tabs tabs={this.Tabs()} />
        <ModalButtons loading={this.state.loading} buttons={buttons} />
        <DatesAndTimesBuilderTabContent {...this.state} {...this.props} onChangeDate = {this.onChangeDate} onChangeTime = {this.onChangeTime} onChangeZone = {this.onChangeZone}/>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  prepParams() {
    var date_setting = {
      time_zone: this.state.time_zone,
      time_format: "",
      date_format: ""
    }
    date_setting.time_format = this.props.time_formats[this.state.time_format]
    date_setting.date_format = this.props.date_formats[this.state.date_format]

    return date_setting
  }

  onSave() {
    var date_setting = this.prepParams()

    var self = this;

    this.setState({loading: true});

    $.ajax({
      type: 'POST',
      url: '/admin/dates-and-times/update',
      data: {
        date_setting: date_setting,
      }
    }).done((data) => {
      window.parent.$(window.parent).trigger('datesAndTimesSaved', data)
      this.setState({loading: false});
      if (parent && parent.refresh_data) {
        // console.log(parent)
        parent.refresh_data(I18n.t('dates_and_times_saved_successfully'));
      }

      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }

    })
  }

  onChangeActiveTab(name) {
    this.setState({
      active_tab: name
    });
  };

  Tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
    );
  };

};

export default DatesAndTimesBuilder
